export const environment = {
    SERVICES: {
        AUTH_SERVICE: {
            API_BASE_URL: process.env.REACT_APP_AUTH_SERVICE_API_BASE_URL || "",
            SYSTEM_NAME: process.env.REACT_APP_AUTH_SERVICE_SYSTEM_NAME || "",
            PRIVATE_KEY: process.env.REACT_APP_AUTH_SERVICE_PRIVATE_KEY || "",
            PUBLIC_KEY: process.env.REACT_APP_AUTH_SERVICE_PUBLIC_KEY || "",
        },
        CLINICAL_TRIAL_SERVICE: {
            API_BASE_URL: process.env.REACT_APP_CLINICAL_TRIAL_SERVICE_API_BASE_URL || "",
            SYSTEM_NAME: process.env.REACT_APP_CLINICAL_TRIAL_SERVICE_SYSTEM_NAME || "",
            PRIVATE_KEY: process.env.REACT_APP_CLINICAL_TRIAL_SERVICE_PRIVATE_KEY || "",
            PUBLIC_KEY: process.env.REACT_APP_CLINICAL_TRIAL_SERVICE_PUBLIC_KEY || "",
        },
        RESEARCHER_PROFILE_SERVICE: {
            API_BASE_URL: process.env.REACT_APP_RESEARCHER_PROFILE_SERVICE_API_BASE_URL || "",
            SYSTEM_NAME: process.env.REACT_APP_RESEARCHER_PROFILE_SERVICE_SYSTEM_NAME || "",
            PRIVATE_KEY: process.env.REACT_APP_RESEARCHER_PROFILE_SERVICE_PRIVATE_KEY || "",
            PUBLIC_KEY: process.env.REACT_APP_RESEARCHER_PROFILE_SERVICE_PUBLIC_KEY || "",
        },
    },
};

export type ServiceName = keyof typeof environment.SERVICES;